export class Constants {
  static apiUrl = Constants.getApiString();
  // static apiUrl = "localhost:5001";
  // static apiUrl = "http://localhost:5000";
  // static apiUrl = "https://admin.pkgloop.com";
  // static setApiString = Constants.getApiString();
  static startingDate = new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 14));
  static threeDaysFromStartingDate = new Date(Constants.startingDate.getTime() + (1000 * 60 * 60 * 24 * 3));
  static version: string = "v1";

  static getApiString(): string {
    const location = window.location;

    if (location.href.includes("localhost")) {
      return "http://localhost:5000";
    }
    else if (location.href.includes("dev")) {
      return "https://admin-dev.pkgloop.com";
    }
    else if (location.href.includes("staging")) {
      return "https://admin-staging.pkgloop.com";
    } else {
      return "https://admin.pkgloop.com";
    }
  }

  // static getApiString(): Promise<string> {
  //   // console.log("in get api url");
  //   return fetch("/api/env")
  //     .then(res => {
  //       const t = res.json();
  //       // console.log("resjson", t);
  //       return t;
  //     })
  //     .then(res => {
  //       // console.log("res", res);
  //       // console.log("res", res);
  //       // console.log("res[Object.keys(res)[0]]", res[Object.keys(res)[0]]);
  //       return Constants.apiUrl = res[Object.keys(res)[0]];
  //     });
  // };
}